import { EditNotificationsOutlined } from "@mui/icons-material"
import { Box, Button, Typography, useTheme } from "@mui/material"
import { DataGrid, GridDeleteIcon } from "@mui/x-data-grid"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import ConfirmationDialog from "../../components/ConfirmationDialog"
import Header from "../../components/Header"
import ProjectApi from "../../services/api/projects"
import { tokens } from "../../theme"
import ProjectForm from "./form"

const Projects = () => {
	const navigate = useNavigate()

	const theme = useTheme()
	const colors = tokens(theme.palette.mode)
	const projectModule = ProjectApi()
	const [projectsList, setProjectsList] = useState([])

	const [isConfirmationOpen, setConfirmationOpen] = useState(false)
	const [selectedId, setSelectedId] = useState("")
	const [editingData, setEditingData] = useState()

	const [open, setOpen] = useState(false)

	const columns = [
		{ field: "id", headerName: "ID" },
		{
			field: "name",
			headerName: "Name",
			flex: 1,
			cellClassName: "name-column--cell",
		},
		{
			field: "description",
			headerName: "Description",
			flex: 1,
		},
		{
			field: "",
			headerName: "Edit",
			flex: 1,
			renderCell: ({ row: { id } }) => {
				return (
					<Box display="flex" justifyContent="center" borderRadius="4px">
						<Typography
							variant="button"
							color="warning"
							onClick={() => editProject(id)}
							style={{ cursor: "pointer", marginRight: "10px" }}
						>
							<EditNotificationsOutlined
								fontSize="small"
								style={{ marginRight: "4px" }}
							/>
							Edit
						</Typography>

						<Typography
							variant="button"
							color="error"
							onClick={() => deleteProject(id)}
							style={{ cursor: "pointer" }}
						>
							<GridDeleteIcon fontSize="small" style={{ marginRight: "4px" }} />
							Delete
						</Typography>
					</Box>
				)
			},
		},
	]

	useEffect(() => {
		fetchData()
	}, [])

	const fetchData = async () => {
		try {
			const data = await projectModule.getAll()

			setProjectsList(data.results)
		} catch (error) {
			console.log(fetchErrorMsg, error)
		}
	}

	const editProject = (id) => {
		const project = projectsList.find((row) => row.id === id)
		setEditingData(project)
		viewForm()
	}

	const deleteProject = (id) => {
		setSelectedId(id)
		handleOpenConfirmation()
	}

	const handleOpenConfirmation = () => {
		setConfirmationOpen(true)
	}

	const handleCloseConfirmation = () => {
		setConfirmationOpen(false)
	}

	const handleConfirmAction = () => {
		try {
			const response = projectModule.destroy(selectedId)

			console.log(deletedSuccessMsg, response)
			fetchData()
		} catch (error) {
			console.log(deleteErrorMsg, error)
		}

		handleCloseConfirmation()
	}

	const createProject = () => {
        setEditingData()
		viewForm()
	}

	const viewForm = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
		fetchData()
	}

	return (
		<>
			<Box m="20px">
				<Header title="Projects" subtitle="" />

				<Box display="flex" justifyContent="end" m="0 0 0 0">
					<Button
						type="submit"
						color="secondary"
						variant="contained"
						onClick={createProject}
					>
						Create Project
					</Button>
				</Box>

				<Box
					m="40px 0 0 0"
					height="75vh"
					sx={{
						"& .MuiDataGrid-root": {
							border: "none",
						},
						"& .MuiDataGrid-cell": {
							borderBottom: "none",
						},
						"& .name-column--cell": {
							color: colors.greenAccent[300],
						},
						"& .MuiDataGrid-columnHeaders": {
							backgroundColor: colors.blueAccent[700],
							borderBottom: "none",
						},
						"& .MuiDataGrid-virtualScroller": {
							backgroundColor: colors.primary[400],
						},
						"& .MuiDataGrid-footerContainer": {
							borderTop: "none",
							backgroundColor: colors.blueAccent[700],
						},
						"& .MuiCheckbox-root": {
							color: `${colors.greenAccent[200]} !important`,
						},
					}}
				>
					<DataGrid rows={projectsList} columns={columns} />
				</Box>
			</Box>

			<ConfirmationDialog
				open={isConfirmationOpen}
				onClose={handleCloseConfirmation}
				onConfirm={handleConfirmAction}
			/>

			<ProjectForm
				formData={editingData}
				open={open}
				handleClose={() => handleClose()}
			/>
		</>
	)
}

const deletedSuccessMsg = "Project deleted successfully: "
const deleteErrorMsg = "Not deleted project. "
const fetchErrorMsg = "Not loading users"

export default Projects
